import { render, staticRenderFns } from "./StudentHistory.vue?vue&type=template&id=0a924d7b&scoped=true&"
import script from "./StudentHistory.vue?vue&type=script&lang=js&"
export * from "./StudentHistory.vue?vue&type=script&lang=js&"
import style0 from "./StudentHistory.vue?vue&type=style&index=0&id=0a924d7b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a924d7b",
  null
  
)

export default component.exports